import React, {useState, useEffect, useContext} from "react";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import {functions} from "../../constants/common-functions";
import AmChartSimpleBar from "../../components/AmChartSimpleBar";
import DashboardToolPanel from "../../components/DashboardToolPanel";
import UtilityDashboardLayout from "../../components/dashboardlayouts/UtilityDashboardLayout";
import {utilityDashboardComponentContainer} from "../../constants/styles";
import ChartCardLarge from "../../components/ChartCardLarge";
import {store} from '../../context/store';

export default function UtilisationOutliers(){
	
	const GROUP_BY_SPACE_TYPE = "GROUP_BY_SPACE_TYPE";
	const GROUP_BY_ORGANISATION = "GROUP_BY_ORGANISATION";
	const GROUP_BY_FLOOR = "GROUP_BY_FLOOR";
	const GROUP_BY_WORKPLACE = "GROUP_BY_WORKPLACE";
	const GROUP_BY_DATE = "GROUP_BY_DATE";
	const GROUP_BY_HOUR = "GROUP_BY_HOUR";
	
	const [groupBy, setGroupBy] = useState(GROUP_BY_SPACE_TYPE);
	const [data1, setData1] = useState([]);
	const [data2, setData2] = useState([]);
	const [loaded, setLoaded] = useState(false);
	
	const globalState = useContext(store);
			
	const utilisationSurveyId =
	    globalState?.state?.queryContext?.utilisationSurveyId ?? null;

	
	useEffect(() => {
		if(loaded === false){
			setLoaded(true);
		}
	
		loadData(groupBy);
		
	}, [utilisationSurveyId]);
	
	const groupBySpaceType =() => {
		setGroupBy(GROUP_BY_SPACE_TYPE);
		loadData(GROUP_BY_SPACE_TYPE);
	};
	
	const groupByOrganisation =() => {
		setGroupBy(GROUP_BY_ORGANISATION);
		loadData(GROUP_BY_ORGANISATION);
	};
	
	const groupByFloor =() => {
		setGroupBy(GROUP_BY_FLOOR);
		loadData(GROUP_BY_FLOOR);
	};
	
	const groupByWorkplace =() => {
		setGroupBy(GROUP_BY_WORKPLACE);
		loadData(GROUP_BY_WORKPLACE);
	};
	
	const groupByDate =() => {
		setGroupBy(GROUP_BY_DATE);
		loadData(GROUP_BY_DATE);
	};
	
	const groupByHour =() => {
		setGroupBy(GROUP_BY_HOUR);
		loadData(GROUP_BY_HOUR);
	};
	
	const reloadData = () => {
		loadData1(groupBy);
		loadData2(groupBy);
	};
	
	const loadData = (thisGroupBy) => {
		loadData1(thisGroupBy);
		loadData2(thisGroupBy);
	};
	
	const loadData1 = (thisGroupBy) => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgettop?limit=20&groupBy=" + thisGroupBy + "&utilisationSurveyId=" + utilisationSurveyId, setData1, handleData1);
	};
	
	const loadData2 = (thisGroupBy) => {
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetbottom?limit=20&groupBy=" + thisGroupBy + "&utilisationSurveyId=" + utilisationSurveyId, setData2, handleData2);
	};
	
	const handleNullName = (code, name) => {
		if(name != null){
			return name;
		}
		else{
			return code;
		}
	};
	
	const handleData1 = (results) => {
	   const tempData = results.map(({id, code, name, value }) => ({
	    id:id,
	    label:handleNullName(code, name),
	    value,
	  }));
	  
	  setData1(tempData);
	};
	
	const handleData2 = (results) => {
	  const tempData = results.map(({id, code, name, value }) => ({
	    id:id,
	    label:handleNullName(code, name),
	    value,
	  }));
	  
	  setData2(tempData);
	};

	
	const refreshFunction = () => {
		reloadData();
	};
	
	
	const toolActions =[
		{label:'Space Type', actionFunction:groupBySpaceType},
		{label:'Organisation', actionFunction:groupByOrganisation},
		{label:'Workplace', actionFunction:groupByWorkplace},
		{label:'Floor', actionFunction:groupByFloor},
		{label:'Date', actionFunction:groupByDate},
		{label:'Hour', actionFunction:groupByHour}
	];
 	
	return (
		<UtilityDashboardLayout
			    title="Utilisation Outliers"
			    childDashboards={childDashboardsUtilisation}
			    refreshFunction={refreshFunction}
			  >
			  <div style={utilityDashboardComponentContainer}>
			  <ChartCardLarge title="Highest Utilisation">
			  	<AmChartSimpleBar
				 	chartId="utilisationprofilesdaily"
				 	chartData={data1}
				 	categoryKey="label"
				 	valueKey="value"
				 	color="blue"
				 	width="100%"
				 	height="calc(100% - 30px)"
					/>
  	  		  </ChartCardLarge>
			 </div>
			 <div style={utilityDashboardComponentContainer}>
			  <ChartCardLarge title="Lowest Utilisation">
			  	<AmChartSimpleBar
				 	chartId="utilisationprofilesweekly"
				 	chartData={data2}
				 	categoryKey="label"
				 	valueKey="value"
				 	color="teal"
				 	width="100%"
				 	height="calc(100% - 30px)"
					/>
				</ChartCardLarge>
			  </div>						
				<DashboardToolPanel
					title="Group By"
					actions={toolActions}
				/>
		</UtilityDashboardLayout>
			
	);
}